import { render, staticRenderFns } from "./new-cart-products.vue?vue&type=template&id=3ec8c814&scoped=true&"
import script from "./new-cart-products.vue?vue&type=script&lang=js&"
export * from "./new-cart-products.vue?vue&type=script&lang=js&"
import style0 from "./new-cart-products.vue?vue&type=style&index=0&id=3ec8c814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8c814",
  null
  
)

export default component.exports